module.exports = __webpack_public_path__ + "static/17-28a6de91f1f430df1049f0399a605230.jpg";